import { Condition } from "@redotech/redo-model/return-flow/condition";
import { validateCustomerEmailSubscriberCondition } from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type CustomerEmailSubscriberState = void;

export const CUSTOMER_EMAIL_SUBSCRIBER = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<CustomerEmailSubscriberState>
  >,
): ConditionType<
  CustomerEmailSubscriberState,
  Condition.CustomerEmailSubscriber
> => ({
  name: "Customer email subscriber",
  description() {
    return "Customer is an email subscriber";
  },
  Details(props: ConditionTypeDetailsProps<CustomerEmailSubscriberState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.CUSTOMER_EMAIL_SUBSCRIBER };
  },
  valid() {
    return validateCustomerEmailSubscriberCondition({}).valid;
  },
});
